import React, { useState } from "react";
import SalesLineChart from "./salesCharts";
import PieChartWithCustomizedLabel from "./salesCharts/paymentMethodChart";
import VerticalComposedChart from "./salesCharts/verticalStoresLine";
import DataTable from "../UI/table/DataTable";
import { formatPrice } from "../../utils/formatPrice";
import StatusBadge from "../UI/statusBadge";
import { useQuery } from "react-query";
import { getWithdrawals } from "../../MyApi/withdrawals";
import { getSalesReports } from "../../MyApi/reports";
import { salesReportsColumns } from "./salesConfig";
import SkeletonWrapper from "../UI/skeletonWrapper";

const SalesReportsTab = ({ statsWidget, isLoading }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const {data,isLoading:salesLoading ,isFetching}=useQuery(["getSalesReports",currentPage],()=>getSalesReports(currentPage))
 const salesReports =data?.data?.sales ||[]
 const currency_factor =data?.data?.currency_factor


 const salesReportsColumns = [
  { label: "التاريخ", accessor: "date" },

  { label: "المتجر", accessor: "store_name" },
  {
    label: "الطلبات",
    render: (row) => <div>{row.order_count}</div>,
  },

  ,
  {
    label: "إجمالي المبيعات",
    render: (row) => (
      <div>
        {formatPrice(currency_factor, row.total_sales)} {row.currency_code}
      </div>
    ),
  },
  {
    label: "المبالغ المستردة",
    render: (row) => (

      <div>

        {formatPrice(currency_factor, row.refunds)} {row.currency_code}
      </div>
    ),
  },

];

  return (
    <div>

        <div className="col-12">      <SkeletonWrapper isLoading={isLoading}>
          <div className="card rounded-4">
            <div className="card-body">
              <h6 className="mb-3">المبيعات علي مدار الوقت</h6>
              <SalesLineChart
                statsWidget={statsWidget?.charts?.sales_over_time}
              />
            </div>
          </div>      </SkeletonWrapper>
        </div>


      <div className="row">
        <div className="col-md-6">
          <SkeletonWrapper isLoading={isLoading}>
            <PieChartWithCustomizedLabel statsWidget={statsWidget} />
          </SkeletonWrapper>
        </div>
        <div className="col-md-6">
          <SkeletonWrapper isLoading={isLoading}>
            <VerticalComposedChart statsWidget={statsWidget} />
          </SkeletonWrapper>
        </div>
      </div>

        <DataTable
          columns={salesReportsColumns}
          data={salesReports || []}
          title="المبيعات"
          totalItems={data?.data?.pagination?.total || 0}
          itemsPerPage={data?.data?.pagination?.last_page ||0}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
           isLoading={salesLoading}
           isFetching={isFetching}
        />

    </div>
  );
};

export default SalesReportsTab;
